import { Outlet } from 'react-router-dom'

import { QuestionType } from '@factorialco/f0-react'

import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import NewFormEditor from 'modules/forms/components/newFormEditor'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const ALLOWED_QUESTION_TYPES: QuestionType[] = [
  'rating',
  'select',
  'multi-select',
  'text',
  'longText',
  'numeric',
  'link',
  'date',
]

export default function TemplateQuestionsPage() {
  const { id } = useStrictParams<'id'>()

  return (
    <ResponsivePage.Body variant="fullscreen">
      <NewFormEditor
        id={id}
        resourceType="Surveys::Survey"
        allowedQuestionTypes={ALLOWED_QUESTION_TYPES}
      />
      <Outlet />
    </ResponsivePage.Body>
  )
}
